import React from 'react';
import { useHistory } from 'react-router-dom';

import { Box, Grid, Typography } from '@material-ui/core';

import sinisterConfirmationImg from '../../../../../../assets/img/inspections/inspection_confirmation.svg';
// import sinisterConfirmationImg from '../../../../../../assets/img/siniestro_confirmado.png';
import FloatingButton from '../../../../../../components/FloatingButton';
import { useSinisterInspectionsContext } from '../../../../../../context/SinisterInspections/SinisterInspections.provider';
import { useAuthDataContext } from '../../../../../../context/auth/auth.provider';

const Confirmation = () => {
  const { cleanSuccess } = useSinisterInspectionsContext();
  const history = useHistory();

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  const handleSubmit = () => {
    redirectHome();
    cleanSuccess();
  };

  return (
    <>
      <Grid container justify="center">
        <Grid item xs={11}>
          <Box my={4}>
            <Typography variant="h6">
              ¡Tu pedido de inspección fue recibido!
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box
            my={6}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <img src={sinisterConfirmationImg} alt={'siniestro'}></img>
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box my={4}>
            <FloatingButton onClick={handleSubmit}>
              Volver al inicio
            </FloatingButton>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Confirmation;
